import React from 'react';

const icon = ({ className = '', ...props }) => (
  <span className={`svg-icon ${className}`} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
      <g fill="none" stroke="currentColor">
        <circle cx="22.5" cy="22.5" r="22" />
        <path d="M20.544 18l-.544.505.272.253 4.537 4.211-4.537 4.212-.272.253.544.505.272-.253 4.536-4.212.034.033.544-.506-.034-.032.034-.032-.544-.505-.033.032-4.537-4.211z" strokeLinecap="square" />
      </g>
    </svg>
  </span>
);

export default icon;
